/**
 * PageInfoForm - Form section for page title, slug, and description
 */
export const PageInfoForm = ({ form, setForm, editingPage, generateSlug }) => {
  return (
    <div className="bg-zinc-900/50 border border-white/10 p-6 space-y-4">
      <h3 className="text-xs font-bold uppercase text-zinc-400">Page Info</h3>
      <div>
        <label className="block text-xs text-zinc-500 mb-2">Title *</label>
        <input
          type="text"
          value={form.title}
          onChange={(e) => {
            setForm({ 
              ...form, 
              title: e.target.value,
              slug: editingPage ? form.slug : generateSlug(e.target.value)
            });
          }}
          className="w-full bg-black border border-white/10 text-white px-4 py-3 focus:outline-none focus:border-white/30"
        />
      </div>
      <div>
        <label className="block text-xs text-zinc-500 mb-2">URL Slug *</label>
        <div className="flex items-center">
          <span className="text-zinc-500 px-3 py-3 bg-zinc-800 border border-white/10 border-r-0">
            {window.location.origin}/
          </span>
          <input
            type="text"
            value={form.slug}
            onChange={(e) => setForm({ ...form, slug: generateSlug(e.target.value) })}
            className="flex-1 bg-black border border-white/10 text-white px-4 py-3 focus:outline-none focus:border-white/30"
          />
        </div>
      </div>
      <div>
        <label className="block text-xs text-zinc-500 mb-2">Description</label>
        <textarea
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
          rows={2}
          className="w-full bg-black border border-white/10 text-white px-4 py-3 focus:outline-none focus:border-white/30 resize-none"
        />
      </div>
    </div>
  );
};

export default PageInfoForm;
